/*
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-04-10 10:12:51
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-10-16 16:08:12
 * @FilePath: /wemeet-admin-new/Users/hvv/weMeetSpace/wemeet-poster/src/api/interNational.js
 * @Description:
 * Copyright (c) 2024 by WeMeet, All Rights Reserved.
 */

import http from "@/utils/httph5";

// 获取国家区号
export function getCountryCode(headers, params) {
  const config = {
    method: "GET",
    url: `/user/country/queryInfo`,
    headers,
    params,
  };
  return http(config);
}

// 邮箱注册
export function emailRegister(headers, data) {
  const config = {
    method: "POST",
    url: `/user/wemeet/email/pre/register`,
    headers,
    data,
  };
  return http(config);
}

// check 邮箱是否可以激活
export function checkEmailStatus(headers, code) {
  const config = {
    method: "GET",
    url: `/user/wemeet/checkActive/${code}`,
    headers,
  };
  return http(config);
}
// check 邮箱再次发送激活
export function checkEmailSendAgain(headers, code) {
  const config = {
    method: "GET",
    url: `/user/wemeet/sendAgain/${code}`,
    headers,
  };
  return http(config);
}

// 邮箱设置密码
export function checkEmail(headers, data) {
  const config = {
    method: "POST",
    url: `/user/wemeet/mail/active`,
    headers,
    data,
  };
  return http(config);
}

// 查询所有省份
export function getProvince(headers) {
  const config = {
    method: "GET",
    url: `/cs/dict/getProvince`,
    headers,
  };
  return http(config);
}

// 查询所有省份
export function getCity(headers, params) {
  const config = {
    method: "GET",
    url: `/cs/dict/getCity`,
    headers,
    params,
  };
  return http(config);
}

export function getAreaByCity(headers, params) {
  const config = {
    method: "GET",
    url: `/cs/dict/getArea`,
    headers,
    params,
  };
  return http(config);
}

// 校验手机号
export function checkPhone(headers, data) {
  const config = {
    method: "POST",
    url: `/user/wemeet/checkPhone`,
    headers,
    data,
  };
  return http(config);
}

// 校验手机号
export function sendYzm(headers, data) {
  const config = {
    method: "POST",
    url: `/user/wemeet/sendPhoneCaptcha`,
    headers,
    data,
  };
  return http(config);
}

// 校验手机号
export function checkPhoneReg(headers, data) {
  const config = {
    method: "POST",
    url: `/user/wemeet/phone/check`,
    headers,
    data,
  };
  return http(config);
}

// 邮箱登录
export function emailLogin(headers, data) {
  const config = {
    method: "POST",
    url: `/user/wemeet/mail/login`,
    headers,
    data,
  };
  return http(config);
}
// 手机号登录
export function phoneLogin(headers, data) {
  const config = {
    method: "POST",
    url: `/user/wemeet/phone/login`,
    headers,
    data,
  };
  return http(config);
}

// 获取用户信息
export function getUserInfo(headers, data) {
  const config = {
    method: "GET",
    url: `/user/user/userInfo`,
    headers,
    data,
  };
  return http(config);
}

/**
 * @description 联系人相关接口
 *  */
// 查询联系人列表
export function getContactList(headers, data) {
  const config = {
    method: "POST",
    url: `/user/contact/queryContact`,
    headers,
    data,
  };
  return http(config);
}

// 查询待添加的联系人列表
export function getWaitContactList(headers, params) {
  const config = {
    method: "GET",
    url: `/user/contact/query/waitContact`,
    headers,
    params,
  };
  return http(config);
}

// 同意添加联系人

export function agreeAddContact(headers, data) {
  const config = {
    method: "POST",
    url: `/user/contact/addContact`,
    headers,
    data,
  };
  return http(config);
}

// 取消添加联系人

export function disagreeAddContact(headers, data) {
  const config = {
    method: "POST",
    url: `/user/contact/cancelContact`,
    headers,
    data,
  };
  return http(config);
}

// 获取多语言名片

export function getUserLanguages(headers, params) {
  const config = {
    method: "GET",
    url: `/user/wemeet/getUserLanguages`,
    headers,
    params,
  };
  return http(config);
}

export function queryUserHomePage(headers, uid, language, shareCode) {
  const config = {
    method: "GET",
    url: `/user/homepage/queryUserHomepage?uid=${uid}&language=${language}&shareCode=${shareCode}`,
    headers,
  };
  return http(config);
}

export function queryMyHomePage(headers, language) {
  const config = {
    method: "GET",
    url: `/user/homepage/queryMyHomepage?language=${language}`,
    headers,
  };
  return http(config);
}

// 二维码 senceKey参数解析
export function handleSenceQrCode(headers, scene) {
  const config = {
    method: "GET",
    url: `/user/qr/getQrCodeConfig/${scene}`,
    headers,
  };
  return http(config);
}

// 查询机构主页详情
export function queryEnterPriseHomePage(headers, params) {
  const config = {
    method: "GET",
    url: `/user/enterprise/homepage`,
    headers,
    params,
  };
  return http(config);
}

// 查询机构主页多语言名片
export function queryEnterPriseHomePageLanguage(headers, params) {
  const config = {
    method: "GET",
    url: `/user/enterprise/homepageLanguage`,
    headers,
    params,
  };
  return http(config);
}
// 查询企业相册
export function photoAlbumQuery(headers, params) {
  const config = {
    method: "GET",
    url: `/user/enterprise/query/photo/album`,
    headers,
    params,
  };
  return http(config);
}

// 查询企业联系人
export function queryContactInfoByType(headers, params) {
  const config = {
    method: "GET",
    url: `/user/enterprise/queryContactInfoByType`,
    headers,
    params,
  };
  return http(config);
}

// 添加企业线索
export function enterpriseAddClue(headers, data) {
  const config = {
    method: "POST",
    url: `user/enterprise/addClue`,
    headers,
    data,
  };
  return http(config);
}

// 查询企业团队接口
export function queryTeamInfo(headers, params) {
  const config = {
    method: "GET",
    url: `user/enterprise/queryTeamInfo`,
    headers,
    params,
  };
  return http(config);
}

// 更新用户信息
export function wemeetUpdate(headers, data) {
  const config = {
    method: "POST",
    url: `user/wemeet/update`,
    headers,
    data,
  };
  return http(config);
}

// 分享 link
export function shareLinkCreate(headers, data) {
  const config = {
    method: "POST",
    url: `user/share/link/create`,
    headers,
    data,
  };
  return http(config);
}

// 截图
export function posterShot(headers, data) {
  const config = {
    method: "POST",
    url: `poster/tools/shot`,
    headers,
    data,
  };
  return http(config);
}

export function imMessageNum(headers, data) {
  const config = {
    method: "GET",
    url: `user/im/message/num`,
    headers,
    data,
  };
  return http(config);
}

// 企业下产品列表
export function productToCQueryList(headers, params) {
  const config = {
    method: "GET",
    url: `user/enterprise/product/toC/queryList`,
    headers,
    params,
  };
  return http(config);
}

// 产品详情
export function productQueryDetail(headers, params) {
  const config = {
    method: "GET",
    url: `/user/enterprise/product/query/detail`,
    headers,
    params,
  };
  return http(config);
}

// 添加关注
export function contactAddFollower(headers, data) {
  const config = {
    method: "POST",
    url: `/user/contact/addFollower`,
    headers,
    data,
  };
  return http(config);
}

// 取消关注
export function cancelFollower(headers, targetUid) {
  const config = {
    method: "POST",
    url: `/user/contact/cancelFollower/${targetUid}`,
    headers,
  };
  return http(config);
}

// 取消关注机构
export function cancelEnterpriseFollower(headers, params) {
  const config = {
    method: "GET",
    url: `/user/contact/cancelEnterpriseFollower`,
    headers,
    params,
  };
  return http(config);
}

// 添加联系人
export function contactInitialRequest(headers, data) {
  const config = {
    method: "POST",
    url: `user/contact/initial/request`,
    headers,
    data,
  };
  return http(config);
}

// 解除联系人
export function contactDelContact(headers, uid) {
  const config = {
    method: "POST",
    url: `user/contact/delContact/${uid}`,
    headers,
  };
  return http(config);
}

// 获取 vcf 二维码
export function getUserVcf(headers, params) {
  const config = {
    method: "GET",
    url: `/user/user/getUserVcf`,
    headers,
    params,
  };
  return http(config);
}

// 获取联系人关联产品信息
export function queryContactInfoProduct(headers, params) {
  const config = {
    method: "GET",
    url: `user/enterprise/queryContactInfoProduct`,
    headers,
    params,
  };
  return http(config);
}

// 查询联系人未添加数量
export function contactQueryWaitContactNum(headers, params) {
  const config = {
    method: "GET",
    url: `user/contact/query/waitContactNum`,
    headers,
    params,
  };
  return http(config);
}

// 编辑用户列表查询用户信息
export function getUserBaseInfo(headers, params) {
  const config = {
    method: "GET",
    url: `/user/wemeet/getUserBaseInfo`,
    headers,
    params,
  };
  return http(config);
}

// 查询关注的机构列表
export function getEnterpriseList(headers, params) {
  const config = {
    method: "GET",
    url: `/user/enterprise/3/getEnterpriseList`,
    headers,
    params,
  };
  return http(config);
}

// 调用新版截屏海报
export function toolsShotPro(headers, data) {
  const config = {
    method: "POST",
    url: `/user/tools/shotPro`,
    headers,
    data,
  };
  return http(config);
}

// 关注展会  展商 展品 产品
export function followList(headers, data) {
  const config = {
    method: "POST",
    url: `/user/interest/interestList`,
    headers,
    data,
  };
  return http(config);
}

// 产品名称自定义
export function enterpriseQuerySearchType(headers, params) {
  const config = {
    method: "GET",
    url: `/user/enterprise/querySearchType`,
    headers,
    params,
  };
  return http(config);
}

// 当前状态是否有入场码
export function checkHasEntrance(headers, meetingCode) {
  const config = {
    method: "POST",
    url: `/user/attend/checkHasEntrance/${meetingCode}`,
    headers,
  };
  return http(config);
}

// 查询会展报名状态
export function checkSign(headers, identity, meetingCode) {
  const config = {
    method: "POST",
    url: `/user/attend/checkSignUpStatus/${identity}/${meetingCode}`,
    headers,
  };
  return http(config);
}

// 获取查询报名设置列表
export function getRegisterConfig(headers, identity, meetingCode) {
  const config = {
    method: "GET",
    url: `/user/meeting/getRegisterConfig/${identity}/${meetingCode}`,
    headers,
  };
  return http(config);
}

// 获取实名认证状态
export function getCheckRealName(headers) {
  const config = {
    method: "GET",
    url: `/user/wemeet/checkRealName`,
    headers,
  };
  return http(config);
}

// 观众报名详情回显接口
export function mySignUpDetail(headers, meetingCode, identity) {
  const config = {
    method: "GET",
    url: `/user/attend/mySignDetail/${meetingCode}/${identity}`,
    headers,
  };
  return http(config);
}

// 观众报名详情回显接口
export function getExhibitionForm(
  headers,
  meetingCode,
  identity,
  relationType,
  type
) {
  const config = {
    method: "POST",
    url: `/user/form/get/${identity}/${relationType}/${meetingCode}/${type}`,
    headers,
  };
  return http(config);
}
export function getMeetingTempDetail(headers) {
  const config = {
    method: "GET",
    url: `/user/meeting/temp/getDetail`,
    headers,
  };
  return http(config);
}

export function getExhibitionDetail(headers, exhibitionCode) {
  const config = {
    method: "GET",
    url: `/user/hold/exhibition/detail/${exhibitionCode}`,
    headers,
  };
  return http(config);
}
export function getHoldMeetDetail(headers, meetingCode) {
  const config = {
    method: "GET",
    url: `user/hold/meeting/detail/${meetingCode}`,
    headers,
  };
  return http(config);
}

export function getHoldMeetDetailEn(headers, params) {
  const config = {
    method: "GET",
    url: `user/hold/meeting/toC/queryTranslationDetail`,
    headers,
    params,
  };
  return http(config);
}

export function getCountryAreaCode(headers, params) {
  const config = {
    method: "GET",
    url: `/user/country/queryInfo`,
    headers,
    params,
  };
  return http(config);
}

// 报名注册
export function signUpAndRegister(headers, data) {
  const config = {
    method: "POST",
    url: `/user/attend/signUpAndRegister`,
    headers,
    data,
  };
  return http(config);
}
// 更新报名注册
export function updateSignUpAndRegister(headers, data) {
  const config = {
    method: "POST",
    url: `/user/attend/updateSignDetail`,
    headers,
    data,
  };
  return http(config);
}

export function upLoadcert(headers, params) {
  const config = {
    method: "POST",
    url: `/user/file/batch/upload`,
    headers,
    data: params,
  };
  return http(config);
}

export function cancelMeeting(headers, params) {
  const config = {
    method: "POST",
    url: `/user/attend/cancel`,
    headers,
    data: params,
  };
  return http(config);
}

export function getAllMeetIdentity(headers) {
  const config = {
    method: "POST",
    url: `/user/meeting/identity/get`,
    headers,
  };
  return http(config);
}

export function exhibitionForumEntranceInfo(headers, meetingCode, meetingType) {
  const config = {
    method: "GET",
    url: `/user/user/exhibition/entranceInfo?meetingCode=${meetingCode}&meetingType=${meetingType}`,
    headers,
  };
  return http(config);
}

export function invitationUse(headers, params) {
  const config = {
    method: "POST",
    url: `/user/meeting/invitation/use`,
    headers,
    data: params,
  };
  return http(config);
}
// export function followList(data){
// 	return reqPost1(`/user/interest/interestList`,data)
// }

export function getEntranceQrCode(headers, fullCardNo, meetingCode) {
  const config = {
    method: "get",
    url: `/user/qr/getEntranceQrCode/${fullCardNo}/${meetingCode}`,
    headers,
  };
  return http(config);
}

export function photoCheck(headers, params) {
  const config = {
    method: "get",
    url: `/user/photo/check`,
    headers,
    params,
  };
  return http(config);
}

export function signUpAndRegisterJbh(headers, data) {
  const config = {
    method: "post",
    url: `/user/attend/signUpAndRegisterJbh`,
    headers,
    data,
  };
  return http(config);
}
